import React from 'react'
import { Manager, Popper, Reference } from 'react-popper'
import { StyledFormElement as FormElement } from '../../common/FormElement'
import { StyledButton as Button } from '../../common/Button'
import Toolbar from '../../common/Toolbar'
import Loader from '../../common/Loader'
import styled from 'react-emotion'
import ThreadNumber from '../ThreadNumber'
import Thread from '../Thread'
import { space, rowHeight } from '../../../style'
import { isLoaded } from 'react-redux-firebase'
import DiscussControls from '../../MainToolbar/DiscussControls'
import Content from 'common/components/Content'

const ScrollArea = styled('div')({
  overflow: 'auto',
  display: 'flex'
})

const DiscussBar = styled(
  ({
    threads,
    smallScreen,
    touchPlacing,
    previewThread,
    mouseEnter,
    mouseLeave,
    showResolved,
    toggleResolvedThreads,
    t,
    className
  }) => (
    <div className={className}>
      {touchPlacing && (
          <Toolbar bottom borderless>
            <FormElement.Spacer />
            <FormElement>{t('discuss.tapToPlace')}</FormElement>
            <FormElement.Spacer />
          </Toolbar>
        )}
      <Toolbar bottom borderless>
        {smallScreen ? (
          <DiscussControls />
        ) : (
          <ScrollArea>
            {!isLoaded(threads) && <Loader borderless />}
            {(threads || []).map((thread, i) => (
              <Manager key={thread.number}>
                <Reference>
                  {({ ref }) => (
                    <DiscussBarThread
                      onMouseEnter={() => mouseEnter(i)}
                      onMouseLeave={() => mouseLeave(i)}
                      innerRef={ref}
                    >
                      <ThreadNumber inline asLink thread={thread} />
                    </DiscussBarThread>
                  )}
                </Reference>
                {previewThread === i && (
                  <Popper
                    placement="top"
                    modifiers={{
                      preventOverflow: {
                        boundariesElement: document.querySelectorAll(
                          Content.toString()
                        )[0],
                        padding: {
                          top: 10,
                          left: 10,
                          right: 10,
                          bottom: 10 + rowHeight.default
                        }
                      }
                    }}
                  >
                    {({ ref, style }) => (
                      <Thread
                        preview
                        thread={thread}
                        style={style}
                        innerRef={ref}
                      />
                    )}
                  </Popper>
                )}
              </Manager>
            ))}
          </ScrollArea>
        )}

        <FormElement.Spacer />

        <Button onClick={toggleResolvedThreads}>
          {showResolved ? t('discuss.hideResolved') : t('discuss.showResolved')}
        </Button>
      </Toolbar>
    </div>
  )
)(({ inline }) => ({
  position: !inline && 'absolute',
  width: '100%',
  bottom: 0
}))

const DiscussBarThread = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${space.small / 2}px`,
  '&:first-child': { paddingLeft: space.small }
})

export default DiscussBar
